/**
 * 把已選但不在選項樹裡的門市／機台補回選項面板（POS-8118）。
 *
 * 版位全部被 BANNED 之後就從 store-options / characteristic 消失（測試模式看的是
 * 測試池，同樣不含），於是面板上整列不見 —— 使用者只在 chip 上看得到，既確認不了
 * 也取消不掉。補的那一列掛在 value 解出來的縣市節點底下；縣市節點本身也不在了就
 * 補一個，否則那一列仍然無處可放。
 */
export function appendSelectedNotInOptions(
  options: SelectOptions[],
  selected: SelectOptions[],
  labelMap?: Map<string | number, string>
): SelectOptions[] {
  if (selected.length === 0) {
    return options;
  }
  const known = new Set<string>();
  options.forEach((parent) => {
    known.add(parent.value.toString());
    (parent.options ?? []).forEach((child) =>
      known.add(child.value.toString())
    );
  });
  const missing = selected.filter(
    (option) => !known.has(option.value.toString())
  );
  if (missing.length === 0) {
    return options;
  }

  // 不能改到傳進來的那棵樹：同一份陣列也是 taOptionsCache 與其他 chip 的來源。
  const byMunicipality = new Map<string, SelectOptions>();
  const merged: SelectOptions[] = options.map((parent) => {
    const clone = { ...parent, options: [...(parent.options ?? [])] };
    byMunicipality.set(clone.value.toString(), clone);
    return clone;
  });

  missing.forEach((option) => {
    const value = option.value.toString();
    const firstSlash = value.indexOf('/');
    // 解不出縣市就無處可掛（CSV 原文之類的殘值），寧可不列也不要掛錯縣市。
    if (firstSlash <= 0) {
      return;
    }
    const municipality = value.slice(0, firstSlash);
    let parent = byMunicipality.get(municipality);
    if (!parent) {
      parent = { label: municipality, value: municipality, options: [] };
      byMunicipality.set(municipality, parent);
      merged.push(parent);
    }
    parent.options?.push({
      label: labelMap?.get(value) ?? option.label ?? value,
      value
    });
  });

  return merged;
}
